// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/main.scss'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import MaskedInput from 'vue-masked-input'
import VueResource from 'vue-resource'

Vue.use(MaskedInput)
Vue.use(VueResource)
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js